import React from "react";

const useCheckEmptyRadioButtonForUiList = (GridList, index) => {
  const [RadioCount, setRadioCount] = React.useState();
  React.useEffect(() => {
    if (GridList) {
      const radioButtons = GridList[index]
        .map(
          (check) => check?.element?.ElsRecord?.Type === "RadioButton" && check
        )
        .filter((fl) => fl && fl.value.toString().length > 0).length;
      setRadioCount(() => radioButtons);
    }
  }, [GridList]);
  return { RadioCount };
};

export default useCheckEmptyRadioButtonForUiList;
